import "regenerator-runtime/runtime";

import React, { Component } from "react";

import InnerHTML from "dangerously-set-inner-html";

// import InfiniteList from "react-infinite-scroll-list";
import { InfiniteScroll } from "react-simple-infinite-scroll";

import InfiniteScrollSimple from "./InfiniteScrollSimple.js";

class SectionList2 extends Component {
  constructor(props) {
    super(props);

    console.log("items: ", props);

    let items;
    props.initialItems
      ? (items = JSON.parse(props.initialItems))
      : (items = []);

    this.state = {
      items: items,
      isLoading: false,
      isEndReached: false
    };

    this.onReachThreshold = this.onReachThreshold.bind(this);
    this.renderList = this.renderList.bind(this);
    this.setDangerousHtml = this.setDangerousHtml.bind(this);
  }

  loadMorePath = () => {
    return `load_more?page=${this.state.items.length}`;
  };

  async onReachThreshold() {
    console.log("onReachThreshold");

    this.setState({ isLoading: true });

    console.log("loading...");

    let response = await fetch(this.loadMorePath());

    let data = await response.json();
    console.log("data: ", data);

    this.setState(({ items }) => {
      return {
        isLoading: false,
        items: items.concat(data)
      };
    });

    this.afterAddItems();
  }

  afterAddItems = () => {
    console.log("afterAddItems");
    // window.instgrm.Embeds.process();
  };

  renderItems = () => {
    return this.state.items.map(item => this.renderItem(item));
  };

  renderItem = item => {
    return <div className={this.props.itemClassName} key={item.id} />;
  };

  renderList(obj) {
    let sentinel = obj.sentinel;

    console.log("renderList: ", sentinel);
    return (
      <div className={this.props.className}>
        {this.renderItems()}
        {sentinel}
      </div>
    );
  }

  render() {
    return (
      <InfiniteScrollSimple
        throttle={100}
        threshold={2000}
        isLoading={this.state.isLoading}
        hasMore={!this.state.isEndReached}
        onLoadMore={this.onReachThreshold}
        render={this.renderList}
      />
    );
  }

  /**
   * Like React's dangerouslySetInnerHTML, but also with JS evaluation.
   * Usage:
   *   <div ref={setDangerousHtml.bind(null, html)}/>
   */
  setDangerousHtml(html, el) {
    // console.log("googletag: ", window.googletag);
    if (el === null) return;
    const range = document.createRange();
    range.selectNodeContents(el);
    range.deleteContents();
    el.appendChild(range.createContextualFragment(html));
  }
}

export default SectionList2;
